// extracted by mini-css-extract-plugin
export default {"avatar":"aRCrzxxGD3StjZDsCYyt","edit-avatar":"mwiiAQzxbRWL_uF59IVV","editAvatar":"mwiiAQzxbRWL_uF59IVV"};